import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "../LandingPage.css";
import LazyLoadingImage from "./LazyLoadingImage";

const imagePaths = [
	"./images/assets/worldorder.png",
	"./images/nochillio_final.png",
	"./images/triangle.png",
	"./images/nochillio_monitor.png",
	"./images/nochill_monitor.png",
];

const preloadedImages = {};
imagePaths.forEach((src) => {
	const img = new Image();
	img.src = src;
	preloadedImages[src] = img;
});

// TV Content for Documentation Pages
const tvContent = {
	badges: {
		title: "BADGE INFO",
		content: `There are two badges available in The Arena associated with this project. Owning one of these badges qualifies the user to appear on the leaderboard.

NOCHILLIO BADGE (LEVEL 1)

Own a nochillio and 1 million NOCHILL tokens in your Arena wallet or a linked external wallet.

The badge shows up as a pale faced icon.

NOCHILL BADGE (LEVEL 2)

That nochillio from Level 1? Make it your PFP on The Arena.

The badge shows up as a blue faced icon.

To climb the ranks, the user can add additional holdings of NOCHILL or nochillio nfts.
`
	},
	faq: {
		title: "FAQ",
		links: [
			{ label: "Avalanche Foundation Blog", url: "https://web.archive.org/web/20250712135030/https://www.avax.network/about/blog/the-avalanche-foundation-discloses-community-coin-holdings" },
			{ label: "Coindesk Article", url: "https://www.coindesk.com/markets/2024/03/15/avalanche-foundation-snaps-up-kimbo-coq-and-three-other-tokens-as-first-meme-coin-investment/" },
			{ label: "Unchained Article", url: "https://unchainedcrypto.com/avalanche-foundation-reveals-its-5-initial-memecoin-holdings/" },
		]
	}
};

const menuItems = [
	{ label: "PIMP MY WIDE", path: "/pimpmywide" },
	{ label: "LEADERBOARD", path: "https://leaderboard.nochill.io/" },
	{ label: "BRIDGE", path: "https://bridge.nochill.io" },
	{ label: "NOCHILL", path: "https://nochill.com" },
	{ label: "NOCHILLIO", path: "https://nochill.io" },
	{ label: "TELEGRAM", path: "https://t.me/nochillavax" },
	{ label: "MY NOCHILLIO", path: "https://my.nochill.io" },
];

const whereToBuyLinks = [
	{ label: "LFJ.gg", url: "https://lfj.gg/avalanche/trade?inputCurrency=AVAX&outputCurrency=0xAcFb898Cff266E53278cC0124fC2C7C94C8cB9a5" },
	{ label: "Pharaoh", url: "https://www.phar.gg/trade?inputCurrency=0x0000000000000000000000000000000000000000&outputCurrency=0xAcFb898Cff266E53278cC0124fC2C7C94C8cB9a5" },
	{ label: "Arena.Trade", url: "https://arena.trade/token/0xacfb898cff266e53278cc0124fc2c7c94c8cb9a5" },
	{ label: "FWX", url: "https://app.fwx.finance/43114/future-trade/0xAcFb898Cff266E53278cC0124fC2C7C94C8cB9a5/0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7" },
	{ label: "Debridge", url: "https://app.debridge.finance/?inputChain=7565164&outputChain=43114&inputCurrency=&outputCurrency=0xacfb898cff266e53278cc0124fc2c7c94c8cb9a5&dlnMode=simple&address=&r=30074" },
	{ label: "OKX Dex", url: "https://www.okx.com/web3/dex-swap#inputChain=43114&inputCurrency=0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE&outputChain=43114&outputCurrency=0xacfb898cff266e53278cc0124fc2c7c94c8cb9a5" },
	{ label: "Coinstore", url: "https://www.coinstore.com/#/spot/NOCHILLUSDT" },
	{ label: "Poloniex", url: "https://poloniex.com/trade/NOCHILL_USDT?type=spot" },
	{ label: "Coinex", url: "https://www.coinex.com/en/exchange/nochill-usdt" },
];

const nochillioLinks = [
	{ label: "Twitter", url: "https://twitter.com/NOCHILLIONAIRE" },
	{ label: "Arena", url: "https://arena.social/NOCHILLIONAIRE" },
	{ label: "Salvor", url: "https://salvor.io/collections/0x204b3ee3f9bdcde258ba3f74de76ea8eedf0a36a" },
	{
		label: "Joepegs",
		url: "https://joepegs.com/collections/avalanche/0x204b3ee3f9bdcde258ba3f74de76ea8eedf0a36a",
	},
	{
		label: "Magic Eden",
		url: "https://magiceden.io/collections/avalanche/0x204b3ee3f9bdcde258ba3f74de76ea8eedf0a36a",
	},
	{ label: "OpenSea", url: "https://opensea.io/collection/nochillio" },
];

const nochillLinks = [
	{ label: "Where to Buy", url: "" },
	//{
	//	label: "Chart",
	//	url: "https://www.tradingview.com/symbols/NOCHILLWAVAX_2D38BD.USD/?offer_id=10&aff_id=5962",
	//},
	{ label: "Badge Info", url: "tv-badges" },
	{ label: "FAQ", url: "tv-faq" },
	{ label: "Twitter", url: "https://x.com/nochillavax" },
	{ label: "Arena", url: "https://arena.social/nochillavax" },
	{ label: "CoinGecko", url: "https://www.coingecko.com/en/coins/avax-has-no-chill" },
	{ label: "CoinMarketCap", url: "https://coinmarketcap.com/currencies/avax-has-no-chill" },
	{ label: "DexScreener", url: "https://www.dexscreener.com/avalanche/0x2d38bde22e044ea59688ca7cdd4f0b5307cc519a" },
	{ label: "DYOR", url: "https://dyor.com/view/avax/0x2d38bde22e044ea59688ca7cdd4f0b5307cc519a" },
];

const LandingPage = () => {
	const navigate = useNavigate();

	const [selectedIndex, setSelectedIndex] = useState(0);
	const [isLandingPageModal, setIsLandingPageModal] = useState(false);
	const [landingPageModalContent, setLandingPageModalContent] = useState(null);
	const [isSubListOpen, setIsSubListOpen] = useState(false);
	const [backgroundClassName, setBackgroundClassName] = useState("");
	const [modalSelectedIndex, setModalSelectedIndex] = useState(0);
	const [subListIndex, setSubListIndex] = useState(0);
	const [isBlinking, setIsBlinking] = useState(true);

	const subListRef = useRef(null);
	const blinkTimeout = useRef(null);

	const handleMenuSelect = useCallback((label, path) => {
		if (label === "NOCHILLIO" || label === "NOCHILL") {
			setLandingPageModalContent(label);
			setIsLandingPageModal(true);
			setBackgroundClassName(label === "NOCHILLIO" ? "nochillio-monitor" : "nochill-monitor");
			setModalSelectedIndex(0);
			setSubListIndex(0);
		} else if (label === "BADGE INFO" || label === "FAQ") {
			setLandingPageModalContent(label);
			setIsLandingPageModal(true);
			setBackgroundClassName("tv-content-monitor");
			setModalSelectedIndex(0);
		} else if (["TELEGRAM", "LEADERBOARD", "MY NOCHILLIO", "BRIDGE"].includes(label)) {
			window.open(path, "_blank");
		} else {
			navigate(path);
		}
	}, [navigate]);

	const closeLandingPageModal = useCallback(() => {
		setIsLandingPageModal(false);
		setLandingPageModalContent(null);
		setIsSubListOpen(false);
	}, []);

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (!isLandingPageModal) {
				if (e.key === "ArrowDown" || e.key === "ArrowUp") {
					clearTimeout(blinkTimeout.current);
					setIsBlinking(false);

					blinkTimeout.current = setTimeout(() => {
						setIsBlinking(true);
					}, 10);

					setSelectedIndex((prevIndex) => {
						if (e.key === "ArrowDown") {
							return (prevIndex + 1) % menuItems.length;
						}
						return (prevIndex - 1 + menuItems.length) % menuItems.length;
					});
				} else if (e.key === "Enter") {
					handleMenuSelect(menuItems[selectedIndex].label, menuItems[selectedIndex].path);
				}
			} else {
				let links = landingPageModalContent === "NOCHILLIO" ? nochillioLinks : nochillLinks;

				if (landingPageModalContent === "NOCHILL" && isSubListOpen) {
					links = whereToBuyLinks;
				}

				if (e.key === "ArrowDown" || e.key === "ArrowUp") {
					clearTimeout(blinkTimeout.current);
					setIsBlinking(false);

					blinkTimeout.current = setTimeout(() => {
						setIsBlinking(true);
					}, 300);

					if (isSubListOpen) {
						setSubListIndex((prevIndex) => {
							if (e.key === "ArrowDown") {
								return (prevIndex + 1) % whereToBuyLinks.length;
							}
							return (prevIndex - 1 + whereToBuyLinks.length) % whereToBuyLinks.length;
						});
					} else {
						setModalSelectedIndex((prevIndex) => {
							if (e.key === "ArrowDown") {
								return (prevIndex + 1) % links.length;
							}
							return (prevIndex - 1 + links.length) % links.length;
						});
					}
				} else if (e.key === "ArrowLeft" && isSubListOpen) {
					setIsSubListOpen(false);
					setModalSelectedIndex(0);
				} else if (e.key === "Enter") {
					if (landingPageModalContent === "NOCHILL" && modalSelectedIndex === 0) {
						// Adjusted to open sublist when "Where to Buy" is selected
						setIsSubListOpen(!isSubListOpen);
						setSubListIndex(0);
					} else {
						const selectedLink = isSubListOpen
							? whereToBuyLinks[subListIndex]
							: links[modalSelectedIndex];
						if (selectedLink.url) {
							// Check if it's Badge Info or FAQ
							if (selectedLink.label === "Badge Info") {
								setLandingPageModalContent("BADGE INFO");
								setBackgroundClassName("tv-content-monitor");
								setModalSelectedIndex(0);
							} else if (selectedLink.label === "FAQ") {
								setLandingPageModalContent("FAQ");
								setBackgroundClassName("tv-content-monitor");
								setModalSelectedIndex(0);
							} else {
								window.open(selectedLink.url, "_blank");
							}
						}
					}
				} else if (e.key === "Escape") {
					closeLandingPageModal();
				}
			}
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => {
			window.removeEventListener("keydown", handleKeyDown);
			clearTimeout(blinkTimeout.current);
		};
	}, [
		selectedIndex,
		isLandingPageModal,
		landingPageModalContent,
		modalSelectedIndex,
		subListIndex,
		isSubListOpen,
		handleMenuSelect,
		closeLandingPageModal,
	]);

	useEffect(() => {
		const interval = setInterval(() => {
			setIsBlinking((prev) => !prev);
		}, 500);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (isSubListOpen && subListRef.current) {
			const sublistElement = subListRef.current;
			const selectedElement = sublistElement.children[subListIndex];

			selectedElement.scrollIntoView({
				behavior: "smooth",
				block: "nearest",
				inline: "start",
			});
		}
	}, [subListIndex, isSubListOpen]);

	const handleClick = (label, path) => {
		handleMenuSelect(label, path);
	};

	const handleCopyAddress = () => {
		navigator.clipboard.writeText("0xacfb898cff266e53278cc0124fc2c7c94c8cb9a5").then(() => {
			alert("Contract address copied to clipboard!");
		});
	};

	return (
		<div className="landing-container">
			{isLandingPageModal && <div className="blur-overlay" />}
			<div className="logo-container">
				<LazyLoadingImage
					src="./images/assets/worldorder.png"
					alt="Nochillio World Order Logo"
					className="logo-image"
				/>
			</div>
			<div className="content-wrapper">
				<div className="person-container">
					<LazyLoadingImage src="./images/nochillio_final.png" alt="Person" />
				</div>
				<div className="menu-container">
					{menuItems.map((item, index) => (
						<div
							key={item.label}
							className={`menu-item 
       ${selectedIndex === index && !isLandingPageModal ? "selected" : ""} 
       ${item.label === "TELEGRAM" ? "telegram-offset" : ""}`}
							onClick={() => handleClick(item.label, item.path)}
						>
							{selectedIndex === index && !isLandingPageModal && (
								<LazyLoadingImage
									src="./images/triangle.png"
									alt="Cursor"
									className={`cursor ${isBlinking ? "blink" : ""}`}
								/>
							)}
							{item.label}
						</div>
					))}
				</div>
			</div>
			{/* Contract Address below the content-wrapper */}
			<div className="contract-address" onClick={handleCopyAddress}>
				CA: 0xacfb898cff266e53278cc0124fc2c7c94c8cb9a5
			</div>

			{isLandingPageModal && (
				<div className="landing-page-modal-overlay" onClick={closeLandingPageModal}>
					<div
						className={`landing-page-modal-content ${backgroundClassName}`}
						style={{
							backgroundImage: `url(${
								backgroundClassName === "nochillio-monitor"
									? "./images/nochillio_monitor.png"
									: "./images/nochill_monitor.png"
							})`,
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<button className="landing-page-modal-close-button" onClick={closeLandingPageModal}>
							X
						</button>
						{landingPageModalContent === "NOCHILLIO" && (
							<div className="landing-page-modal-text">
								<p className="landing-page-modal-header">NOCHILLIO</p>
								<ul>
									{nochillioLinks.map((link, index) => (
										<li key={link.label} className={modalSelectedIndex === index ? "selected" : ""}>
											{modalSelectedIndex === index && (
												<LazyLoadingImage
													src="./images/triangle.png"
													alt="Cursor"
													className={`cursor-small ${isBlinking ? "blink" : ""}`}
												/>
											)}
											<a href={link.url} target="_blank" rel="noopener noreferrer">
												{link.label}
											</a>
										</li>
									))}
								</ul>
							</div>
						)}
						{landingPageModalContent === "NOCHILL" && (
							<div className="landing-page-modal-text">
								<p className="landing-page-modal-header">NOCHILL&nbsp;&nbsp;</p>
								<ul>
									{nochillLinks.map((link, index) => (
										<li className={modalSelectedIndex === index ? "selected" : ""} key={link.label}>
											{modalSelectedIndex === index && (
												<LazyLoadingImage
													src="./images/triangle.png"
													alt="Cursor"
													className={`cursor-small ${isBlinking ? "blink" : ""}`}
												/>
											)}
											{link.label === "Badge Info" || link.label === "FAQ" ? (
												<button
													className="link-button"
													onClick={(e) => {
														e.preventDefault();
														let content = link.label === "Badge Info" ? "BADGE INFO" : "FAQ";
														setLandingPageModalContent(content);
														setBackgroundClassName("tv-content-monitor");
														setModalSelectedIndex(0);
													}}
												>
													{link.label}
												</button>
											) : link.label === "Where to Buy" ? (
												<button
													className="link-button"
													onClick={(e) => {
														e.preventDefault();
														setIsSubListOpen(!isSubListOpen);
														setSubListIndex(0);
													}}
												>
													{link.label}
												</button>
											) : link.url ? (
												<a href={link.url} target="_blank" rel="noopener noreferrer">
													{link.label}
												</a>
											) : (
												<span>{link.label}</span>
											)}
											{modalSelectedIndex === index && isSubListOpen && (
												<ul className="sub-list" ref={subListRef}>
													{whereToBuyLinks.map((sublink, subIndex) => (
														<li key={sublink.label} className={subListIndex === subIndex ? "selected" : ""}>
															{subListIndex === subIndex && (
																<LazyLoadingImage
																	src="./images/triangle.png"
																	alt="Cursor"
																	className={`cursor-small ${isBlinking ? "blink" : ""}`}
																/>
															)}
															<a href={sublink.url} target="_blank" rel="noopener noreferrer">
																{sublink.label}
															</a>
														</li>
													))}
												</ul>
											)}
										</li>
									))}
								</ul>
							</div>
						)}
						{landingPageModalContent === "BADGE INFO" && (
							<div className="landing-page-modal-text tv-scrollable-content">
								<p className="landing-page-modal-header">{tvContent.badges.title}</p>
								<div className="tv-content-body">
									{tvContent.badges.content}
								</div>
							</div>
						)}
						{landingPageModalContent === "FAQ" && (
							<div className="landing-page-modal-text tv-scrollable-content">
								<p className="landing-page-modal-header">{tvContent.faq.title}</p>
								<div className="tv-content-body">
									<p>1. WHAT IS NOCHILL?</p>
									<p>NOCHILL is a memecoin on the Avalanche blockchain. It was launched on December 18, 2023 and a portion of supply was airdropped to users of The Arena. The token is 100% circulating, contract ownership renounced, and initial liquidity is burned.</p>

									<p>2. WHAT ARE NOCHILLIOS?</p>
									<p>nochillio is the first Remilia derivative on Avalanche. Their heads are notably wider.</p>

									<p>3. HAS NOCHILL BEEN IN THE PRESS?</p>
									<p>Yes! We survived the Memecoin Rush apocalypse.</p>
									<ul className="tv-links-list">
										{tvContent.faq.links.map((link, index) => (
											<li key={index}>
												<a href={link.url} target="_blank" rel="noopener noreferrer">
													{link.label}
												</a>
											</li>
										))}
									</ul>
								</div>
							</div>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default LandingPage;
